// extracted by mini-css-extract-plugin
module.exports = {"section":"copyright_section__20k9m","divider":"copyright_divider__2t-iH","copyrightContainer":"copyright_copyrightContainer__1NayG","copyright":"copyright_copyright__1y2Y_"};